function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h18.258v5.186H0V0zm18.322 6.187v12.56H0S2.243 12.626 8.162 9c5.55-3.438 10.16-2.812 10.16-2.812z",
  fill: "#232942"
});

var SvgPro7 = function SvgPro7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMEgxOC4yNTgxVjUuMTg1NjRIMFYwWk0xOC4zMjE3IDYuMTg2NzdWMTguNzQ3OEgwQzAgMTguNzQ3OCAyLjI0MzQ3IDEyLjYyNDggOC4xNjI1IDguOTk4OTNDMTMuNzExNCA1LjU2MDU5IDE4LjMyMTcgNi4xODY3NyAxOC4zMjE3IDYuMTg2NzdaIiBmaWxsPSIjMjMyOTQyIi8+Cjwvc3ZnPgo=";
export { SvgPro7 as ReactComponent };